import type { CarePhase, StepStatus } from '../api/flowApi';

export const PHASE_LABELS: Record<CarePhase, string> = {
  ENROLLED: 'Înrolat',
  SCREENING: 'Screening',
  SCREENED_NEGATIVE: 'Screening negativ — recontrol',
  DIAGNOSTIC_WORKUP: 'Diagnostic în curs',
  DIAGNOSED: 'Diagnosticat',
  IN_TREATMENT: 'În tratament',
  FOLLOW_UP: 'Follow-up',
  CLOSED: 'Închis',
};

export const PHASE_COLORS: Record<CarePhase, string> = {
  ENROLLED: 'default',
  SCREENING: 'blue',
  SCREENED_NEGATIVE: 'green',
  DIAGNOSTIC_WORKUP: 'orange',
  DIAGNOSED: 'volcano',
  IN_TREATMENT: 'purple',
  FOLLOW_UP: 'cyan',
  CLOSED: 'default',
};

export const STEP_STATUS_LABELS: Record<StepStatus, string> = {
  NOT_STARTED: 'Neînceput',
  DRAFT: 'În lucru',
  COMPLETED: 'Finalizat',
  REOPENED: 'Redeschis',
};

export const STEP_STATUS_COLORS: Record<StepStatus, string> = {
  NOT_STARTED: 'default',
  DRAFT: 'blue',
  COMPLETED: 'green',
  REOPENED: 'orange',
};

export const ROLE_LABELS: Record<string, string> = {
  ASISTENT: 'Asistent medical',
  DERMATOLOG: 'Dermatolog',
  HEPATOLOG: 'Hepatolog / Gastroenterolog',
  CHIRURG: 'Chirurg',
  ONCOLOG: 'Oncolog',
  ANATOMOPATOLOG: 'Anatomopatolog',
  RADIOLOG: 'Radiolog',
};
